<template>
	<v-expansion-panels v-model="panel" flat accordion>
		<ExpansionPanel :title="'Basics'">
			<SettingSwitch
				:title="'Label'"
				:placeholder="'Type your title here'"
				:switchValue.sync="titleEnabled"
				:textFieldValue.sync="titleValue"
			/>
		</ExpansionPanel>

		<ExpansionPanel title="Buttons">
			<MultipleSelectSettingsEditor :localField="localField" :options="dropdownOptions" @onChange="onChange" />
		</ExpansionPanel>

		<ExpansionPanel title="Style">
			<SettingSelectInput
				title="Alignment"
				placeholder="Select alignment"
				:items="alignmentOptions"
				:selection.sync="alignmentStyleSelection"
			/>
		</ExpansionPanel>

		<ExpansionPanel :title="'Explanations'">
			<SettingSwitch
				:title="'Description'"
				:placeholder="'Type your description here'"
				:switchValue.sync="descriptionEnabled"
				:textFieldValue.sync="descriptionValue"
			/>
		</ExpansionPanel>
	</v-expansion-panels>
</template>

<script>
import FieldSettingsMixin, { getComputedMetadataOption } from '@/components/BlockEditorWidget/FieldSettings/FieldSettingsMixin';

import SettingSwitch from '../WidgetSettings/SettingSwitch';
import SettingSelectInput from '../WidgetSettings/SettingSelectInput';
import ExpansionPanel from '../WidgetSettings/ExpansionPanel';
import MultipleSelectSettingsEditor from './MultipleSelectSettingsEditor';

const selectOption = (text, value) => ({ text, value });

export default {
	name: 'EndRunButtonsFieldSettings',
	mixins: [FieldSettingsMixin],
	components: {
		SettingSwitch,
		ExpansionPanel,
		MultipleSelectSettingsEditor,
		SettingSelectInput,
	},
	data() {
		return {
			alignmentOptions: [selectOption('Right', 'right'), selectOption('Center', 'center'), selectOption('Left', 'left')],
		};
	},
	computed: {
		alignmentStyleSelection: getComputedMetadataOption('alignment_style'),
		dropdownOptions: getComputedMetadataOption('button_items'),
	},
	methods: {
		onChange(result) {
			this.dropdownOptions = result;
		},
	},
};
</script>

<style scoped lang="scss"></style>
